module.exports = __webpack_public_path__ + "img/21.44568984.svg";